import { render, staticRenderFns } from "./MaingroupReport.vue?vue&type=template&id=8568391c"
import script from "./MaingroupReport.vue?vue&type=script&lang=js"
export * from "./MaingroupReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports